import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Eye, EyeOff, Lock, User, LogIn, AlertCircle } from "lucide-react";
import gambarlogin2 from "../../assets/gambarLogin2.png";
import logoOJK from "../../assets/OJK-logo.png";
import logoAFPI from "../../assets/AFPI-logo.png";
import "./LoginAdmin.scss";
import Swal from "sweetalert2";
import { loginAdmin } from "../../api";

export default function LoginAdmin() {
  const [adminId, setAdminId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await loginAdmin(adminId, password);

      if (rememberMe) {
        localStorage.setItem("adminToken", data.token);
      } else {
        sessionStorage.setItem("adminToken", data.token);
      }

      navigate("/admin/dashboard");
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Login Gagal",
        text: err.message,
        confirmButtonColor: "#ef4444",
      });
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="login-page-admin">
      <motion.div
        className="login-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="login-visual admin">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <img src={gambarlogin2} alt="Login Visual" />
          </motion.div>
          <h2>Admin Portal</h2>
          <p>Kelola data nasabah dan sistem.</p>
        </div>

        <div className="login-form-container">
          <div className="form-header">
            <h3>Masuk Admin</h3>
            <p>Silakan masukkan ID Admin dan password</p>
          </div>

          <form onSubmit={handleSubmit}>
            {error && (
              <motion.div
                className="error-message"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
              >
                <AlertCircle size={18} />
                <span>{error}</span>
              </motion.div>
            )}

            <div className="input-group">
              <label>ID Admin</label>
              <div className="input-wrapper">
                <User className="icon-left" size={20} />
                <input
                  type="text"
                  value={adminId}
                  required
                  onChange={(e) => setAdminId(e.target.value)}
                  placeholder="Masukkan ID Admin"
                />
              </div>
            </div>

            <div className="input-group">
              <label>Password</label>
              <div className="input-wrapper">
                <Lock className="icon-left" size={20} />
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  required
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Masukkan password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="toggle-password"
                  aria-label={showPassword ? "Sembunyikan password" : "Perlihatkan password"}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <div className="remember-forgot">
              <label className="remember-me">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                Simpan login
              </label>
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={loading}
            >
              {loading ? "Memproses..." : (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                  Masuk <LogIn size={18} />
                </span>
              )}
            </button>
          </form>

          <div className="partners-footer">
            <img src={logoOJK} alt="OJK" />
            <img src={logoAFPI} alt="AFPI" />
          </div>
        </div>
      </motion.div>
    </div>
  );
}
